var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9006 15.2H2V15C2 12.1025 2.57794 8.8176 4.27164 6.24267C5.98346 3.64018 8.81337 1.80005 13.2 1.80005C17.5866 1.80005 20.4165 3.64018 22.1284 6.24267C23.8221 8.8176 24.4 12.1025 24.4 15V15.2H23.4994V15C23.4994 12.193 22.9356 9.09814 21.371 6.71947C19.8246 4.36838 17.2796 2.68106 13.2 2.68106C9.12038 2.68106 6.57545 4.36838 5.02899 6.71947C3.46439 9.09814 2.9006 12.193 2.9006 15V15.2Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18947 21.3974H3.2C1.98497 21.3974 1 20.4125 1 19.1974V16.8816C1 15.6666 1.98497 14.6816 3.2 14.6816H5.18947V21.3974ZM4.28947 15.5816H3.2C2.48203 15.5816 1.9 16.1637 1.9 16.8816V19.1974C1.9 19.9154 2.48203 20.4974 3.2 20.4974H4.28947V15.5816Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2104 14.6816H23.1999C24.4149 14.6816 25.3999 15.6666 25.3999 16.8816V19.1974C25.3999 20.4125 24.4149 21.3974 23.1999 21.3974H21.2104V14.6816ZM23.1999 15.5816H22.1104V20.4974H23.1999C23.9179 20.4974 24.4999 19.9154 24.4999 19.1974V16.8816C24.4999 16.1637 23.9179 15.5816 23.1999 15.5816Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8505 21.0119C19.106 22.2041 18.4997 22.9616 17.7909 23.4958C17.3062 23.8612 16.7607 24.1317 16.0656 24.3585L16.281 25.0246C17.0309 24.78 17.6511 24.4777 18.2122 24.0548C19.0241 23.4429 19.6849 22.5987 20.4442 21.3827L20.4972 21.2979L19.9034 20.9271L19.8505 21.0119Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0947 26.2499C15.7923 26.2499 16.3579 25.6844 16.3579 24.9868C16.3579 24.2892 15.7923 23.7236 15.0947 23.7236C14.3971 23.7236 13.8315 24.2892 13.8315 24.9868C13.8315 25.6844 14.3971 26.2499 15.0947 26.2499Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5052 11.7237C11.5052 12.1829 11.1329 12.5552 10.6736 12.5552C10.2144 12.5552 9.84204 12.1829 9.84204 11.7237C9.84204 11.2644 10.2144 10.8921 10.6736 10.8921C11.1329 10.8921 11.5052 11.2644 11.5052 11.7237Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0316 11.7237C14.0316 12.1829 13.6593 12.5552 13.2 12.5552C12.7407 12.5552 12.3684 12.1829 12.3684 11.7237C12.3684 11.2644 12.7407 10.8921 13.2 10.8921C13.6593 10.8921 14.0316 11.2644 14.0316 11.7237Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5579 11.7237C16.5579 12.1829 16.1856 12.5552 15.7264 12.5552C15.2671 12.5552 14.8948 12.1829 14.8948 11.7237C14.8948 11.2644 15.2671 10.8921 15.7264 10.8921C16.1856 10.8921 16.5579 11.2644 16.5579 11.7237Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8038 15.3781C19.7665 14.3786 20.3475 13.1095 20.3475 11.7238C20.3475 8.43839 17.1081 5.8396 13.2001 5.8396C9.29212 5.8396 6.05273 8.43839 6.05273 11.7238C6.05273 15.0092 9.29212 17.608 13.2001 17.608L13.4862 17.6081L13.7722 17.6082H18.8038V15.3781ZM18.1061 14.8045C18.9602 13.9408 19.4475 12.8686 19.4475 11.7238C19.4475 9.09506 16.7873 6.7396 13.2001 6.7396C9.6129 6.7396 6.95273 9.09506 6.95273 11.7238C6.95273 14.3525 9.6129 16.708 13.2001 16.708L14.6722 16.7082H17.9038V15.009L18.1061 14.8045Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportHover);
export default __webpack_public_path__ + "static/media/support-hover.fb487d80.svg";
export { ForwardRef as ReactComponent };